import React from 'react';
import { ClientData } from '../types/ClientData';
import ProgrammeMap from '../components/ProgrammeMap';

interface SessionTwoIntroProps {
  clientData: ClientData;
  onBegin: () => void;
}

function formatCurrency(n: number): string {
  return n > 0 ? `£${n.toLocaleString()}` : '—';
}

export default function SessionTwoIntro({ clientData, onBegin }: SessionTwoIntroProps) {
  const totalMonthly =
    (clientData.pensionCompanyFunded || 0) +
    (clientData.planIsaMonthlyContribution || clientData.isaContribution || 0) +
    (clientData.planMortgageOverpayment || clientData.mortgageOP || 0);

  return (
    <div className="max-w-4xl mx-auto p-8">
      <span style={{
        background: '#64DAD2',
        color: '#001F8C',
        fontSize: '11px',
        fontWeight: 700,
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
        padding: '4px 12px',
        borderRadius: '20px',
        display: 'inline-block',
        marginBottom: '16px',
      }}>
        Session 2 of 3
      </span>
      <h1 style={{ fontSize: '32px', fontWeight: 700, color: '#001F8C', marginBottom: '8px' }}>
        Business Engine
      </h1>
      <p style={{ fontSize: '20px', fontStyle: 'italic', color: '#6b7280', marginBottom: '32px' }}>
        "Can your business fund the life you just planned?"
      </p>

      <p style={{ fontSize: '12px', fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '16px' }}>
        What {clientData.clientName || 'your client'} committed in Session 1
      </p>

      <div style={{ display: 'flex', gap: '16px', marginBottom: '32px', flexWrap: 'wrap' }}>
        {[
          { label: 'Monthly committed', value: formatCurrency(totalMonthly), sub: 'Pension, ISA, and mortgage' },
          { label: 'Your target for today', value: formatCurrency(clientData.gapAmount || 0), sub: 'Gap remaining to close' },
          { label: 'Gap closed so far', value: clientData.totalGapClosed && clientData.gapAmount ? `${Math.round((clientData.totalGapClosed / clientData.gapAmount) * 100)}%` : '—', sub: 'Personal levers only' },
        ].map((card, i) => (
          <div key={i} style={{
            flex: '1 1 180px',
            background: 'white',
            border: '1px solid #e5e7eb',
            borderRadius: '12px',
            padding: '20px',
          }}>
            <p style={{ fontSize: '12px', color: '#6b7280', marginBottom: '8px' }}>{card.label}</p>
            <p style={{ fontSize: '24px', fontWeight: 700, color: '#001F8C', marginBottom: '4px' }}>{card.value}</p>
            <p style={{ fontSize: '12px', color: '#9ca3af' }}>{card.sub}</p>
          </div>
        ))}
      </div>

      <p style={{ fontSize: '16px', color: '#374151', marginBottom: '12px' }}>
        Today we inspect the business engine that funds {clientData.clientName || 'their'} freedom.
      </p>
      {['Diagnose profitability against your peers', 'Model the seven profit levers', 'Optimise corporation tax with the employer pension strategy'].map((item, i) => (
        <div key={i} style={{ display: 'flex', gap: '10px', marginBottom: '8px' }}>
          <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#64DAD2', marginTop: '6px', flexShrink: 0 }} />
          <p style={{ fontSize: '15px', color: '#374151' }}>{item}</p>
        </div>
      ))}

      {/* Programme Map — Brief 26 Section 4c */}
      <div style={{ marginTop: 32, marginBottom: 32 }}>
        <ProgrammeMap currentSession={2} completedSessions={[1]} clientName={clientData.clientName} />
      </div>

      <button
        onClick={onBegin}
        style={{
          marginTop: '0',
          background: '#64DAD2',
          color: '#001F8C',
          border: 'none',
          borderRadius: '8px',
          padding: '14px 32px',
          fontSize: '16px',
          fontWeight: 600,
          cursor: 'pointer',
          fontFamily: 'inherit',
        }}
      >
        Begin Session →
      </button>
    </div>
  );
}
